module.exports = "<nv-react-component component=\"SkillTagsDashboard\"></nv-react-component>";